import {type Annotation, isSquareAnnotation} from "./ImageAnnotation.js";
import type {Shape} from "./types.js";

function getShape(value: Annotation): Shape {
  if (isSquareAnnotation(value)) {
    return {
      x: value.x,
      y: value.y,
      width: value.width,
      height: value.height,
      color: value.color,
    };
  }
  const maxX = Math.max(...value.points.filter((_, index) => index % 2 === 0));
  const minX = Math.min(...value.points.filter((_, index) => index % 2 === 0));
  const maxY = Math.max(...value.points.filter((_, index) => index % 2 === 1));
  const minY = Math.min(...value.points.filter((_, index) => index % 2 === 1));
  const width = maxX - minX;
  const height = maxY - minY;
  return {
    x: value.x + (value.points[0] ?? 0),
    y: value.y + (value.points[1] ?? 0),
    width,
    height,
    color: value.color,
  };
}

function getTextLocation(width: number, _height: number, annotation: Annotation) {
  const labelLength = annotation.label.length * 4;
  if (isSquareAnnotation(annotation)) {
    let x = annotation.x;
    if (annotation.x + annotation.height + labelLength > width - 20) {
      x = annotation.x - labelLength;
    }
    let y = annotation.y - 20;
    if (y < 20) {
      y = annotation.y + annotation.height + 10;
    }

    return {
      x,
      y,
    };
  }
  const minX = Math.min(...annotation.points.filter((_, index) => index % 2 === 0));
  const maxX = Math.max(...annotation.points.filter((_, index) => index % 2 === 0));
  const minY = Math.min(...annotation.points.filter((_, index) => index % 2 === 1));
  const maxY = Math.max(...annotation.points.filter((_, index) => index % 2 === 1));
  let x = annotation.x + minX;
  let y = annotation.y + minY - 20;
  if (y < 20) {
    y = annotation.y + maxY + 10;
  }
  if (x < 0) {
    x = annotation.x + maxX + 10;
  }
  if (annotation.x + maxX + labelLength > width - 20) {
    x = annotation.x + minX - labelLength;
  }
  return {
    x,
    y,
  };
}

export const shapeService = {
  getShape,
  getTextLocation,
};
